import { Component, OnInit, ViewChild } from '@angular/core';
import { SettingService } from '../../../../../common/services/Setting.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-setting-retarget',
  templateUrl: './setting-retarget.component.html',
  styleUrls: ['./setting-retarget.component.css'],
  providers: [SettingService],
})

export class SettingRetargetComponent implements OnInit {
  @ViewChild('notification') notification: ModalDirective;
  modalNotification: BsModalRef;
  public isSendSMS: Boolean;
  public isSendZalo: Boolean;
  public checkSwitchSMS: Boolean = false;
  public checkSwitchZalo: Boolean = false;

  public list_sms_value = [
    { value: 1, label: '' },
    { value: 2, label: '' },
    { value: 3, label: '' },
    { value: 4, label: '' },
    { value: 5, label: '' },
    { value: 6, label: '' },
    { value: 7, label: '' },
    { value: 8, label: '' },
    { value: 9, label: '' }
  ];
  public list_zalo_value = [
    { value: 1, label: '' },
    { value: 2, label: '' },
    { value: 3, label: '' },
    { value: 4, label: '' },
    { value: 5, label: '' },
    { value: 6, label: '' },
    { value: 7, label: '' },
    { value: 8, label: '' },
    { value: 9, label: '' }
  ];
  public selected_sms: any
  public selected_zalo: any
  public current_app_send_config: any;

  constructor(
    private settingService: SettingService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
  }

  async ngOnInit() {
    this.translate.onLangChange.subscribe(() => {
      this.updateLabels();
      this.initSelect2();
    });
    this.updateLabels();
    await this.getInfoRetarget();
    setTimeout(() => {
      this.initSelect2();
    }, 100);
  }

  updateLabels() {
    this.list_sms_value.forEach(item => {
      item.label = this.translate.instant('RETARGET_SCENARIO_' + item.value);
    });
    this.list_zalo_value.forEach(item => {
      item.label = this.translate.instant('RETARGET_SCENARIO_' + item.value);
    });
  }

  initSelect2() {
    $(`#list_script_sms`).select2({
      placeholder: this.translate.instant('CHON_KICH_BAN'),
    });
    $(`#list_script_zalo`).select2({
      placeholder: this.translate.instant('CHON_KICH_BAN'),
    });
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getInfoRetarget(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.settingService.getInfoRetarget().subscribe((res) => {
        this.selected_sms = []
      this.selected_zalo = []
      console.log('123123213', res)
      if (res.code === 1) {
        this.current_app_send_config = res.data.app_send_config;

        if (res.data.app_send_config.sms.cms_accept) {
          this.isSendSMS = res.data.app_send_config.sms.is_send
        } else {
          this.isSendSMS = res.data.app_send_config.sms.cms_accept
          this.checkSwitchSMS = true
        }
        if (res.data.app_send_config.zalo.cms_accept) {
          this.isSendZalo = res.data.app_send_config.zalo.is_send
        } else {
          this.isSendZalo = res.data.app_send_config.zalo.cms_accept
          this.checkSwitchZalo = true
        }
        // Lọc sms
        const getSelectedSMS = res.data.app_send_config.sms.when_send
        const filterGetSelectedSMS = Object.keys(getSelectedSMS).reduce((result, key) => {
          if (getSelectedSMS[key].is_send === true) {
            result[key] = getSelectedSMS[key];
          }
          return result;
        }, {});
        console.log('filterGetSelectedSMS', filterGetSelectedSMS)
        if (this.isEmpty(filterGetSelectedSMS) == false) {
          // tslint:disable-next-line:forin
          for (const key in filterGetSelectedSMS) {
            if (key == 'first_verify') {
              this.selected_sms.push(1)
            } else if (key == 'active_guarantee') {
              this.selected_sms.push(2)
            } else if (key == 'verify') {
              this.selected_sms.push(3)
            } else if (key == 'counterfeit_warning') {
              this.selected_sms.push(4)
            } else if (key == 'receive_warranty') {
              this.selected_sms.push(5)
            } else if (key == 'update_warranty') {
              this.selected_sms.push(6)
            } else if (key == 'complete_or_disclaimer_warranty') {
              this.selected_sms.push(7)
            } else if (key == 'reminder_maintain') {
              this.selected_sms.push(8)
            } else if (key == 'reminder_expired') {
              this.selected_sms.push(9)
            }
          }
        } else {
          this.selected_sms = []
        }
        // Lọc zalo
        const getSelectedZalo = res.data.app_send_config.zalo.when_send;
        const filterGetSelectedZalo = Object.keys(getSelectedZalo).reduce((result, key) => {
          if (getSelectedZalo[key].is_send === true) {
            result[key] = getSelectedZalo[key];
          }
          return result;
        }, {});
        if (this.isEmpty(filterGetSelectedZalo) == false) {
          // tslint:disable-next-line:forin
          for (const key in filterGetSelectedZalo) {
            if (key == 'first_verify') {
              this.selected_zalo.push(1)
            } else if (key == 'active_guarantee') {
              this.selected_zalo.push(2)
            } else if (key == 'verify') {
              this.selected_zalo.push(3)
            } else if (key == 'counterfeit_warning') {
              this.selected_zalo.push(4)
            } else if (key == 'receive_warranty') {
              this.selected_zalo.push(5)
            } else if (key == 'update_warranty') {
              this.selected_zalo.push(6)
            } else if (key == 'complete_or_disclaimer_warranty') {
              this.selected_zalo.push(7)
            } else if (key == 'reminder_maintain') {
              this.selected_zalo.push(8)
            } else if (key == 'reminder_expired') {
              this.selected_zalo.push(9)
            }
          }
        } else {
          this.selected_zalo = []
        }

      } else {
        this.notification.show();
      }
      console.log('hello', this.selected_zalo, this.selected_sms)
      resolve(true);
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
      reject(error);
    })
    });
  }

  async resetRetarget() {
    await this.getInfoRetarget();
    $('#list_script_sms').val(this.selected_sms);
    $('#list_script_sms').trigger('change');
    $('#list_script_zalo').val(this.selected_zalo);
    $('#list_script_zalo').trigger('change');
  }

  submitRetarget() {
    const body_zalo = $(`#list_script_zalo`).val()
    const body_sms = $(`#list_script_sms`).val()
    console.log('tyepaeas', body_zalo, body_sms)
    const payload_config = this.current_app_send_config ? JSON.parse(JSON.stringify(this.current_app_send_config)) : { zalo: { when_send: {} }, sms: { when_send: {} } };
    
    payload_config.zalo.is_send = this.isSendZalo;
    const zalo_scenarios = [
      { key: 'first_verify', val: '1' },
      { key: 'active_guarantee', val: '2' },
      { key: 'verify', val: '3' },
      { key: 'counterfeit_warning', val: '4' },
      { key: 'receive_warranty', val: '5' },
      { key: 'update_warranty', val: '6' },
      { key: 'complete_or_disclaimer_warranty', val: '7' },
      { key: 'reminder_maintain', val: '8' },
      { key: 'reminder_expired', val: '9' }
    ];
    for (const sc of zalo_scenarios) {
      if (!payload_config.zalo.when_send[sc.key]) {
        payload_config.zalo.when_send[sc.key] = {};
      }
      payload_config.zalo.when_send[sc.key].is_send = body_zalo != null && body_zalo.includes(sc.val) ? true : false;
    }

    payload_config.sms.is_send = this.isSendSMS;
    const sms_scenarios = [
      { key: 'first_verify', val: '1' },
      { key: 'active_guarantee', val: '2' },
      { key: 'verify', val: '3' },
      { key: 'counterfeit_warning', val: '4' },
      { key: 'receive_warranty', val: '5' },
      { key: 'update_warranty', val: '6' },
      { key: 'complete_or_disclaimer_warranty', val: '7' },
      { key: 'reminder_maintain', val: '8' },
      { key: 'reminder_expired', val: '9' }
    ];
    for (const sc of sms_scenarios) {
      if (!payload_config.sms.when_send[sc.key]) {
        payload_config.sms.when_send[sc.key] = {};
      }
      payload_config.sms.when_send[sc.key].is_send = body_sms != null && body_sms.includes(sc.val) ? true : false;
    }

    const body = {
      'app_send_config': payload_config
    }
    console.log('aaa', body)
    // return
    this.settingService.updateInfoRetarget(body).subscribe((res) => {
      if (res.code == 1) {
        this.toastr.success(this.translate.instant('CAU_HINH_DICH_VU_RETARGET_THANH_CONG'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        })
      } else {
        this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        })
      }
      console.log('reasa', res)
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
    })
  }

  changeSMS(event) {
    this.isSendSMS = event.target.checked
    console.log('event', event.target.checked)
  }

  changeZalo(event) {
    this.isSendZalo = event.target.checked
    console.log('event', event.target.checked)
  }

  checkDisableSMS() {
    console.log('váo ádaskdoasdkoaskd1111')
    if (this.checkSwitchSMS == true) {
      this.toastr.warning(this.translate.instant('YEU_CAU_ADMIN_TAO_DICH_VU_RETARGET'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
    }
  }

  checkDisableZalo() {
    console.log('váo ádaskdoasdkoaskd1111')
    if (this.checkSwitchZalo == true) {
      this.toastr.warning(this.translate.instant('YEU_CAU_ADMIN_TAO_DICH_VU_RETARGET'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-retarget/setting-retarget.component.ts